<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>

            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>

                <!-- Location PARAMS -->
                <div class="panel-tag mt-2">
                    {{__t("SENDPULSE_LOCATION_PARAMS")}}
                </div>

                <div class="form-group mt-2">
                    <label class="form-label" for="choice_acc">
                        {{__t("SENDPULSE_TRIGGER_ID")}}*
                    </label>

                    <div class="" v-if="a360list.length > 0">
                        <v-select v-model="location_company_id"
                                  class="imc_reasons"
                                  :reduce="item => item.id"
                                  label="name"
                                  :options="a360list"
                                  :filterable="false"
                        >
                            <template slot="no-options">
                                --
                            </template>

                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    <div>
                                        {{ option.name }}
                                    </div>
                                    <div>
                                        <small>{{option.id}}</small>
                                    </div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>


                <div class="form-group mt-2" >
                    <label class="form-label">
                        {{__t('SAVE_HOOK_ORDER')}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <b-form-radio-group
                            id="btn-radios-1"
                            v-model="use_hook"
                            button-variant="outline-primary"
                            :options="[
                                      { text: __t('YES'), value: true },
                                      { text:  __t('NO'), value: false }
                            ]"
                            name="radios-btn-default"
                            buttons
                        ></b-form-radio-group>
                    </div>
                </div>


                <location_general_params :show_payment=false :show_shipment=false :location="location">

                </location_general_params>

            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";

export default {
    name: "sendpulse_general_tab",

    components : {
        Location_general_params,
        vSelect
    },

    props : {
        location : {
            type : Object
        }
    },

    mounted() {
        this.load_a360();
    },

    data() {
        return {
            a360list : [],
            restaurants : [],
        }
    },

    methods : {

        on_change_value(val) {

        },

        async load_a360() {
            let self = this;
            self.a360list = [];

            await agr_api.get('aggregators/sendpulse/a360/').then(({data}) => {
                if (data.status === "operation_success") {
                    self.a360list = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

    },
    computed: {

        location_company_id: {
            get() {
                return this.location.general_fields.company_id;
            },
            set(val) {
                this.location.general_fields.company_id = val;
            }
        },

        use_hook : {
            get() {
                return this.location.general_fields.save_hook_order;
            },
            set(val) {
                this.location.general_fields.save_hook_order = val;
            }
        },

        general_fields() {

            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if(key != 'id') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }

                return res;
            }
            return [];
        },

    }
}
</script>

<style scoped>

</style>
